require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./step-two-animated-widget.json") })
        }
      }, "path---step-two-animated-widget");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---step-two-animated-widget!./.cache/json/step-two-animated-widget.json
// module id = 415
// module chunks = 231608221292675